/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Card, PageState } from '@myob/myob-widgets';
import notFound from 'assets/images/notFound.svg';

export type Props = {
    hasLatestBill?: boolean;
};

const getEmptyBillContent = (hasLatestBill: boolean): { title: string; description: string } => {
    if (hasLatestBill) {
        return {
            title: "You don't have any more bills",
            description: "When more bills are issued, they'll appear here.",
        };
    }
    return {
        title: "You haven't been issued any bills yet",
        description:
            "You'll be able to view and manage your monthly bills for all of your subscriptions and accounts here.",
    };
};

export const EmptyBills: React.FC<Props> = ({ hasLatestBill = true }) => {
    const { title, description } = getEmptyBillContent(hasLatestBill);
    return (
        <Card>
            <PageState title={title} description={description} image={<img src={notFound} alt="No result found" />} />
        </Card>
    );
};

export default EmptyBills;
